import { render, staticRenderFns } from "./ProjetosFiltros.vue?vue&type=template&id=3ee74cad"
import script from "./ProjetosFiltros.vue?vue&type=script&lang=js"
export * from "./ProjetosFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports